/* GET ROLES */
export const GET_INSURANCE_CARRIERS = "GET_INSURANCE_CARRIERS"
export const GET_INSURANCE_CARRIERS_SUCCESS = "GET_INSURANCE_CARRIERS_SUCCESS"
export const GET_INSURANCE_CARRIERS_ERROR = "GET_INSURANCE_CARRIERS_ERROR"